export var ADDON_ID = "@storybook/addon-styling";
export var THEME_SWITCHER_ID = "".concat(ADDON_ID, "/theme-switcher");
export var PARAM_KEY = "theming";
export var GLOBAL_KEY = "theme";
export var DEFAULT_ADDON_STATE = {
  themesList: [],
  themeDefault: undefined
};
export var DEFAULT_THEME_PARAMETERS = {};
export var THEMING_EVENTS = {
  REGISTER_THEMES: "".concat(THEME_SWITCHER_ID, "/REGISTER_THEMES")
};